import Vue from 'vue';
import App from './App';
import router from './router';
import AwesomeSwiper from 'vue-awesome-swiper';
import VueResource from 'vue-resource';

Vue.config.productionTip = false;

// 轮播组件
Vue.use(AwesomeSwiper);

// fetch
Vue.use(VueResource);

Vue.http.options.emulateJSON = true;

new Vue({
  	el: '#app',
  	router,
  	template: '<App/>',
  	components: {
  		App,
  	},
});



// WEBPACK FOOTER //
// ./client/www/main.js